export default __webpack_public_path__ + "static/media/3031 spice rack C side.f480044e.png";